module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slidein"
    }
  }, [(_vm.showing || _vm.lockshowing) ? _c('div', {
    staticClass: "pullsheet",
    attrs: {
      "id": "pullsheet"
    }
  }, [(_vm.state === 'singlesheet') ? _c('div', {
    staticClass: "singlesheet"
  }, [_c('h2', [(_vm.user.loggedIn) ? _c('a', {
    staticClass: "managesheets",
    on: {
      "click": function($event) {
        return _vm.manageSheets()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_none")])]) : _vm._e(), _vm._v(" "), (!_vm.editName) ? [_c('a', {
    staticClass: "editname",
    on: {
      "click": function($event) {
        _vm.editName = true, _vm.newName = _vm.activePullSheet.name
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("mode_edit")])]), _vm._v("\n        " + _vm._s(_vm.activePullSheet.name) + "\n      ")] : _vm._e(), _vm._v(" "), (_vm.editName) ? [_c('form', {
    staticClass: "rename",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.renameSheet()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    ref: "editnamefield",
    attrs: {
      "type": "text",
      "name": "name",
      "maxlength": "24"
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "blur": function($event) {
        return _vm.renameSheet()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    ref: "thumbpanel",
    staticClass: "panel-content thumbs"
  }, [(_vm.activePullSheet.items.length > 0) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.deleteAllPhotos
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete")]), _vm._v(" Delete All")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'https://api.therenees.com/pullsheet/pdf/' + _vm.activePullSheet.token,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("insert_drive_file")]), _vm._v(" Download .pdf")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.showLink = !_vm.showLink
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("link")]), _vm._v(" Share Link")]), _vm._v(" "), (_vm.showLink) ? _c('div', {
    staticClass: "sharelink"
  }, [_c('input', {
    ref: "linkinput",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": 'https://www.therenees.com/pullsheet/' + _vm.activePullSheet.token
    },
    on: {
      "click": function($event) {
        return $event.target.select()
      }
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.showLink = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_vm._v("Copy Link")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/pullsheet/' + _vm.activePullSheet.token
    }
  }, [_vm._v("Visit")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "photos"
  }, [_vm._l((_vm.activePullSheet.items), function(photo, photoindex) {
    return [_c('div', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "imgwrapper"
    }, [_c('img', {
      attrs: {
        "src": 'https://img.therenees.com/' + photo.url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deletePhoto(photo.url, photoindex)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/location/' + photo.reneeid
      }
    }, [_vm._v(_vm._s(photo.reneeid))])], 1)]), _vm._v(_vm._s(' ') + "\n            ")]
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.activePullSheet.items.length === 0) ? _c('div', {
    staticClass: "emptypullsheet"
  }, [_c('h4', [_vm._v("Pullsheet Is Empty")]), _vm._v(" "), _c('p', [_vm._v("To get started click the Add To Pullsheet button on any photo.")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.state === 'managesheets') ? _c('div', {
    staticClass: "managesheets"
  }, [_c('h2', [_vm._v("My Pullsheets")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "pullsheets"
  }, [_c('ul', [_vm._l((_vm.allPullSheets), function(pullsheet) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.setPullSheet(pullsheet)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.copyPullSheet(pullsheet.token)
        }
      }
    }, [_vm._v("content_copy")]), _vm._v(" "), _c('i', {
      staticClass: "material-icons button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deletePullSheet(pullsheet.token)
        }
      }
    }, [_vm._v("delete")]), _vm._v("\n            " + _vm._s(pullsheet.name) + "\n            "), _c('small', [_vm._v(_vm._s(pullsheet.items.length) + " Photos"), (pullsheet.timestamp) ? [_vm._v(", Created " + _vm._s(pullsheet.timestamp))] : _vm._e()], 2)])
  }), _vm._v(" "), _c('li', {
    staticClass: "new",
    on: {
      "click": function($event) {
        return _vm.setPullSheet({
          token: false
        })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add_box")]), _vm._v(" New Pullsheet")])], 2)]) : _vm._e()])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7823a876","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PullSheet.vue
// module id = 211
// module chunks = 1